@use "sass:map";
@import '../../styles/variables.scss';

.select {
    width: 100%;
    position: relative;

    &.active {
      &.error {
        .button1 {
          border: 1px solid map.get($colors-red, 100);
          background-color: #FEF4F4;
        }
      }
      .button1 {
        border: 1px solid map.get($colors-basic, "primaryBlue");

        &:hover:not(:disabled) {
          background-color: map.get($colors-basic, "inputGrey");
        }

        &:disabled {
          text-align: center;
          padding-right: 12px;
          padding-left: 12px;
        }

        .selectAngle {
          transform: translateY(-40%) rotate(-180deg);
        }
      }
    }

    &.text, &.textColor {
      &.active {
        .button1 {
          border: none;
        }
      }
      .button1 {
        cursor: pointer;
        height: auto;
        border: none;
        background-color: inherit;

        &:focus, &:hover:not(:disabled) {
          border: none;
          background-color: inherit;
        }
      }

      ul.options {
        top: 28px;

        li {
          padding: 6px 0;
        }
      }
    }

    &.textColor {
      .button1 {
        color: map.get($colors-basic, "primaryBlue");

        .selectAngle {
          * {
             fill: map.get($colors-basic, "primaryBlue");
          }
        }
      }

      ul.options {
        min-width: 138px;
        right: 0;
      }
    }

    &.error {
      .button1 {
        border: 1px solid map.get($colors-red, 100);
        background-color: #FEF4F4;

        &:hover {
          border: 1px solid map.get($colors-red, 100) !important;
          background-color: #FEF4F4 !important;
        }
      }
    }

    .button1 {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        color: map.get($colors-basic, "textBlack");
        outline: none;
        font-size: map.get($font-sizes, "body");
        background-color: map.get($colors-basic, "inputGrey");
        height: 36px;
        padding-right: 28px;
        padding-left: 12px;
        border: 1px solid map.get($colors-basic, "inputGrey");
        border-radius: 4px;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .selectAngle {
          position: absolute;
          right: 12px;
          top: 45%;
          transform: translateY(-50%);
          transition: transform .2s;
        }

        .placeholder {
          color: map.get($colors-basic, "textGray");
          cursor: default;
        }

        .selectedTitle {
          display: flex;
          flex-direction: row;
          align-items: center;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        &:hover:not(:disabled) {
          background-color: map.get($colors-basic, "selectedOption");
        }

        &:focus {
          border: 1px solid map.get($colors-basic, "primaryBlue");
        }

        &:disabled {
          padding-right: 12px;
          padding-left: 12px;
        }
      }
    
      ul.options {
        max-height: 200px;
        overscroll-behavior: none;
        overflow: auto;
        z-index: 9999;
        background-color: #fff;
        box-sizing: border-box;
        position: absolute;
        top: 40px;
        width: 100%;
        display: none;
        list-style: none;
        margin-top: 0px;
        border-radius: 4px;
        box-shadow: 0px 2px 6px rgba(8,8,40, 0.1);

        &.top {
          top: unset;
          bottom: 40px;
        }

        &.show {
            display: block;
        }

        li {
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 8px 0 9px 0;
            margin: 0 12px;
            border-bottom: 1px solid map.get($colors-basic, "divider");
            text-align: start;
            overflow: hidden;

            span {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            
            &.delete {
              color: map.get($colors-red, 100);
            }
            
            &.hidden {
              display: none;
            }

            &[disabled] {
              color: map.get($colors-basic, "textDisabled");
            }
            
            &:last-child {
              border-bottom: none;
            }
          }
          
        li:active,
        li[aria-selected="true"] {
          color: map.get($colors-basic, "primaryBlue");

          span {
            padding-right: 12px;
          }

          .iconSelected {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        li:active,
        li:focus,
        li:hover,
        li[aria-selected="true"] {
          cursor: pointer;
        }
      }

    &.button1Like {
      .button1 {
        font-weight: 600;
        cursor: pointer;
        background-color: map.get($colors-basic, "secondary");
        &:hover {
          background-color: map.get($colors-basic, "secondary");
          border: 1px solid map.get($colors-basic, "textGray");
          &:disabled {
            border: 1px solid transparent;
          }
        }

        &[disabled] {
          cursor: default;
        }
  
        .placeholder {
          color: map.get($colors-basic, "textBlack");
          cursor: default;
        }
      }

      ul.options {
        width: 200px;
        right: 0;
      }

      &.active {
        .button1 {
          border: 1px solid map.get($colors-basic, "textGray");
        }
      }
    }
}

.selectedTitles {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 4px;
  flex: 1 0 0;
  cursor: default;
  overflow: hidden;
}

.selectedChip {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 2px 4px 2px 8px;
    margin: 0;
    border-radius: 4px;
    border: 1px solid #E8E9ED;
    background-color: #F1F4FF;
    gap: 6px;

    color: #080828;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    .iconSelected {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    .closeGroup {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
    }
}

